"use client";

import { useEffect } from "react";
import { useSessionAuth } from "@/app/_utils/providers/SessionAuthProvider";
import { useUserStore } from "@/app/_store/userStore";

/** Syncs SessionAuthProvider session to the zustand user store. */
export default function SessionToStoreSync() {
  const { session, status } = useSessionAuth();
  const setFromSession = useUserStore((s) => s.setFromSession);
  const logout = useUserStore((s) => s.logout);
  const setHasHydrated = useUserStore((s) => s.setHasHydrated);

  useEffect(() => {
    if (status === "loading") return;
    setHasHydrated(true);
    if (status === "authenticated" && session?.user) {
      setFromSession(session.user as any);
    } else {
      logout();
    }
  }, [status, session?.user, setFromSession, logout, setHasHydrated]);

  return null;
}
